import './ErrorPage.scss';

const ErrorPage = () => {

  return (
    <div className="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
    </div>
  );
};


export default ErrorPage;
